module.exports = __webpack_public_path__ + "assets/Upload-Cloud.37d890f1.svg";